// store/currencyStore.ts
import { create } from "zustand";
import { getAllCurrencies, addCurrency } from "../services";

export interface Currency {
  id?: string;
  currency: string;
  rate: number;
}

interface CurrencyState {
  currencies: Currency[];
  loading: boolean;
  error: string | null;
  fetchCurrencies: () => Promise<void>;
  addNewCurrency: (currency: Currency) => Promise<void>;
}

export const useCurrencyStore = create<CurrencyState>((set, get) => ({
  currencies: [],
  loading: false,
  error: null,

  fetchCurrencies: async () => {
    set({ loading: true, error: null });
    try {
      const data = await getAllCurrencies();
      set({ currencies: data, loading: false });
    } catch (err: any) {
      set({ error: err.message || "Failed to fetch currencies", loading: false });
    }
  },

  addNewCurrency: async (currency: Currency) => {
    set({ loading: true, error: null });
    try {
      const newCurrency = await addCurrency(currency);
      // append the new currency to the state
      set({ currencies: [...get().currencies, newCurrency], loading: false });
    } catch (err: any) {
      set({ error: err.message || "Failed to add currency", loading: false });
    }
  },
}));
